import React, { Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import muiTheme from 'common-mui/theme';
import Loading from 'common-mui/components/FullScreenLoading';
import SnackbarProvider from '../SnackbarProvider';
import Layout from '../Layout';
import Checkpoint from '../Checkpoint';

const Apply = () => (
  <ThemeProvider theme={muiTheme}>
    <CssBaseline />
    <SnackbarProvider>
      <Layout>
        <Suspense fallback={<Loading />}>
          <Checkpoint />
        </Suspense>
      </Layout>
    </SnackbarProvider>
  </ThemeProvider>
);

export default Apply;
